import { EnterLicenseModalTranslations } from "./types";

export const enTranslations: EnterLicenseModalTranslations = {
    title: "Enter License",
    submitButtonText:"Submit",
    buyNowButtonText:"Buy Now",
    dontHaveLicenseText: `Don${"'"}t have a license?${" "}`
};

